
export function saveListQuery(obj) {
  sessionStorage.setItem('__LIST_QUERY__', JSON.stringify(obj))
}

export function initListQuery(listQuery, keepAlive) {
  if (!keepAlive || keepAlive.length === 0) return listQuery

  let storage = sessionStorage.getItem('__LIST_QUERY__')
  const from = sessionStorage.getItem('__FROM_PATH__')
  if (!storage || !from) return listQuery

  if (keepAlive.indexOf(from) > -1) {
    storage = JSON.parse(storage)
    listQuery = { ...listQuery, ...storage }
  }
  return listQuery
}
